import { Component } from '@angular/core';
import { NavController, PopoverController, AlertController, ActionSheetController } from 'ionic-angular';
import { Http } from '@angular/http';
import { MessageService } from './message.service';
import { DatastoreService } from './datastore.service';
import { CredentialsService } from './credentials.service';
import { HubService } from './hub.service'
import { WidgetBase } from './widget-base'

@Component({
  templateUrl: 'widget.html'
})

export class Widget extends WidgetBase {

  constructor(
      public alertCtrl: AlertController,
      public actionSheetCtrl: ActionSheetController,
      public navCtrl: NavController,
      public http: Http,
      public popoverCtrl: PopoverController,
      public messageService: MessageService,
      public datastoreService: DatastoreService,
      public credentialsService: CredentialsService,
      public hubService: HubService,
    ) {
      super(
        alertCtrl,
        actionSheetCtrl,
        navCtrl,
        http,
        popoverCtrl,
        messageService,
        datastoreService,
        credentialsService,
        hubService,
        Number(localStorage.getItem('pageNumberGlobal')),
        localStorage.getItem('autoRefresh'))
  }
}



// WEBPACK FOOTER //
// ./src/app/widget.component.ts